jQuery(function ($) {

    VendorsSearch.init({
        inputSelector: '#review-vendor',
        autoSelect: true,
        companyIdInpSelector: '#vendor_id'
    });

    jQuery('#write_review_form').on('submit', function (e) {
        e.preventDefault();

        var $form = jQuery(this);
        var formData = $form.serializeArray();

        Page.startLoad('submit-review', '#submit_review_btn');

        jQuery.post(ajaxurl, formData, function (result) {
            Page.finishLoad('submit-review');

            //validation errors
            if (typeof result.errors !== 'undefined' && result.errors.length > 0) {
                Validator.validate($form, result.errors);
            } else if (typeof result.success !== 'undefined' && result.success && typeof result.redirect !== 'undefined') {
                window.location.href = result.redirect;
            }

        }, 'json');
    });
});